import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { LegacyLayout } from './layouts/Legacy/Legacy';

export const AppRoot = () => (
    <Router>
        <LegacyLayout isGuest={typeof window !== 'undefined' && !window.Customer} />
    </Router>
);
